import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button, EmptyState } from '@/ui';

export function NotFoundRoute() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <EmptyState
      tone="error"
      title={t('errors.notFound')}
      description={t('errors.notFoundDetail')}
      action={
        <Button
          tone="neutral"
          onClick={() => {
            // navigate() basename'i kendisi ekler. Ham window.location.assign('/')
            // yazilsaydi uygulama alt yoldan servis edildiginde disari duserdi
            // — bkz. src/app-base.ts.
            void navigate('/');
          }}
        >
          {t('errors.backHome')}
        </Button>
      }
    />
  );
}
